import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref } from "vue";
import ModalBox from "@/components/v2/Modal/ModalBox.vue";
import { useFishTransfer } from "@/composables/tasks/animal-transfer/useAnimalTransfer";

interface Props {
    amount: number;
    showModal: boolean;
    toggleFishTransferLogModal: () => void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TransferLogModal',
  props: {
    amount: { default: 0 },
    showModal: { type: Boolean, default: false },
    toggleFishTransferLogModal: {}
  },
  setup(__props: any) {

const props = __props;

const comment = ref("");
const { addCommentOnTask } = useFishTransfer();

const handleInput = () => {
    addCommentOnTask(comment.value, props.amount);
};

return (_ctx: any,_cache: any) => {
  return (_ctx.showModal)
    ? (_openBlock(), _createBlock(ModalBox, {
        key: 0,
        onClose: _ctx.toggleFishTransferLogModal
      }, {
        header: _withCtx(() => _cache[3] || (_cache[3] = [
          _createTextVNode("Explain difference in planned and actual amount")
        ])),
        main: _withCtx(() => [
          _withDirectives(_createElementVNode("textarea", {
            class: "w-full h-28 rounded resize-none p-2 outline-secondary border border-gray-400 required",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((comment).value = $event)),
            onInput: handleInput
          }, null, 544), [
            [_vModelText, comment.value]
          ])
        ]),
        footer: _withCtx(() => [
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleFishTransferLogModal && _ctx.toggleFishTransferLogModal(...args))),
            type: "button",
            class: "text-white bg-primary focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover: focus:z-10"
          }, " Save "),
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleFishTransferLogModal && _ctx.toggleFishTransferLogModal(...args))),
            type: "button",
            class: "text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10"
          }, " Close ")
        ]),
        _: 1
      }, 8, ["onClose"]))
    : _createCommentVNode("", true)
}
}

})